// Разбор журнала переходов: откуда задача вошла в `escalated` и по какой
// причине. Чистая логика без DOM — баннер эскалации только выбирает по
// результату текст.
//
// Вид причины определяет последний вход в `escalated`: исходный статус и
// наличие `reason` у события. Пустой `reason` отличает исчерпание попыток
// (`mark_escalated` для красного CI и `mark_review_rounds_escalated` для
// раундов ревью в `backend/modules/task/service/terminal.py` журнал-причину
// не пишут) от эскалации автоматикой из той же фазы
// (`mark_recovery_escalated` в `backend/modules/task/service/escalation.py`
// пишет причину всегда). Эскалация разбором `infra` статус не меняет и
// события не создаёт: вид текста по ней не меняется, её обоснование
// показывает строка причины из `task.escalation_reason`.

import type { TaskStatusEventResponse } from "./api";

export type EscalationCause =
  | "ci_retries_exhausted"
  | "review_rounds_exhausted"
  | "awaiting_approval"
  | "other";

// Последний вход в `escalated` по журналу (порядок по `at` по возрастанию);
// `undefined`, если входа нет.
export function lastEscalationEntry(
  events: readonly TaskStatusEventResponse[],
): TaskStatusEventResponse | undefined {
  return [...events].reverse().find((event) => event.to_status === "escalated");
}

export function escalationCause(
  events: readonly TaskStatusEventResponse[],
): EscalationCause {
  const entry = lastEscalationEntry(events);
  if (entry?.from_status === "awaiting_approval") {
    return "awaiting_approval";
  }
  if (entry?.reason !== null) {
    return "other";
  }
  if (entry.from_status === "ci_running") {
    return "ci_retries_exhausted";
  }
  if (entry.from_status === "review") {
    return "review_rounds_exhausted";
  }
  return "other";
}
